import "./index.css"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useGlobal } from "../../../../context/global"
import PageLoader from "../../../../components/info/pageloader"
import moment from "moment"
import DP from "../../../../components/custom/dp"
import Icon from "../../../../components/custom/icon"

const PreacherHome = () => {
    const { auth, api } = useGlobal()
    const { user } = auth
    const navigate = useNavigate()

    const [homeData, setHomeData] = useState()

    useEffect(() => {
        api.call('/get-home-data', user).then(({ data }) => {
            setHomeData(data)
        }).catch(err => {
            console.error("Failed to load preacher home data", err)
        })
    }, [])

    if (!homeData) {
        return <PageLoader text="Loading preacher dashboard..." />
    }

    const { sevas, stats } = homeData

    return (
        <div className="preacher-home flex-col">
            <div className="welcome-banner">
                <h2>Hare Krishna, {user.initiationName || user.name}</h2>
                <p>Preacher Dashboard</p>
            </div>

            <div className="stats-container">
                <div className="stat-card pending" onClick={() => navigate("/applicants", { state: { tab: 1 } })}>
                    <div className="stat-icon">
                        <Icon name="pending_actions" color="var(--surface)" size={10} />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.pendingReview}</h3>
                        <p>Pending Applicants</p>
                    </div>
                </div>

                <div className="stat-card approved" onClick={() => navigate("/volunteers")}>
                    <div className="stat-icon">
                        <Icon name="group" color="var(--green)" size={10} />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.totalVolunteers}</h3>
                        <p>My Volunteers</p>
                    </div>
                </div>
            </div>

            <div className="upcoming-festivals">
                <h3>Upcoming Festivals & Sevas</h3>
                {sevas && sevas.length > 0 ? (
                    <div className="festival-list flex-col">
                        {sevas.map(seva => (
                            <div className="festival-card flex-row" key={seva.id}>
                                <div className="festival-dp">
                                    <DP url={`https://cdn.iskconmysore.org/content?path=sevabase/seva/${seva.id}.jpg`} size={[14, 5]} enlarge />
                                </div>
                                <div className="festival-info flex-col">
                                    <span className="festival-name bold">{seva.name}</span>
                                    <span className="festival-date">
                                        {seva.date === seva.maxDate 
                                            ? moment(seva.date).format("dddd, Do MMM YYYY") 
                                            : `${moment(seva.date).format("ddd, Do")} - ${moment(seva.maxDate).format("ddd, Do MMM")} ${moment(seva.date).format("YYYY")}`}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="no-festivals">No upcoming festivals found.</div>
                )}
            </div>
        </div>
    )
}

export default PreacherHome
